// @ts-nocheck
/* eslint-disable */
/* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */
import { ReactComponent as LogoTrino } from '../../../assets/images/Logos/logo-trino.svg?react';
import { withLogoClass } from '../../withLogoClass';
export const LogoTrinoIcon = /* @__PURE__ */ withLogoClass(LogoTrino);
